import React from 'react'
import {  Col, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown } from 'reactstrap'
import { useAuth } from "context/AuthProvider";
import { useParams } from 'react-router-dom';
import { apiexportacionService } from "services/apiExportacionService";


const EmpleadoDetallesGenerales = (props) => {


    const {empresa} = useAuth()
    const {id} = useParams(); 
    const fecha =new Date();
    const anno =fecha.getFullYear();

    const handleDescargarFichaEmpleado = async () =>{
      await apiexportacionService.getFichaEmpleado(empresa.id, id,anno);
    }
    const handleDescargarFichaHorario = async () =>{
        await apiexportacionService.getFichaHorario(empresa.id,id,anno);
      }
    const handleDescargarFichaCalendario = async () =>{
        await apiexportacionService.getFichaCalendario(empresa.id,id,anno);
    }
 


    return (
        <>
            <div className='mb-3'>
                <Row>
                    <Col>
                        <h3 className='mb-2'>Datos generales:</h3>
                    </Col>
                    <Col lg={2}>
                        <UncontrolledDropdown>
                            <DropdownToggle
                               
                                href=""
                                role="button"
                                size="lg"
                                color="primary"
                                caret
                                onClick={(e) => e.preventDefault()}
                            >
                                <i className="ni ni-cloud-download-95" /> Imprimir
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-arrow" right>
                                
                                <DropdownItem onClick={handleDescargarFichaEmpleado}>Ficha completa</DropdownItem>
                                <DropdownItem onClick={handleDescargarFichaHorario}>Horario</DropdownItem>
                                <DropdownItem onClick={handleDescargarFichaCalendario}>Calendario</DropdownItem>
                                
                              
                               
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </Col>
                </Row>

                <Row className='mb-1'>
                    <Col><strong>Nombre:</strong> {props.empleado?.nombre}</Col>

                    <Col><strong>Apellidos:</strong> {props.empleado?.apellidos}</Col>
                </Row>
                <Row className='mb-1'>
                    <Col><strong>Departamento:</strong> {props.empleado?.departamento}</Col>
                    <Col><strong>Centro:</strong> {props.empleado?.centro}</Col>
                    <Col><strong>Horario:</strong> {props.empleado?.horario}</Col>
                </Row>
                <Row className='mb-1'>
                    <Col><strong>Fecha de alta:</strong> {props.empleado?.fechaAlta}</Col>
                    <Col><strong>Fecha de baja:</strong>{props.empleado?.fechaBaja}</Col>
                </Row>
                <Row className='mb-1'>
                    <Col><strong>Vacaciones anuales permitidas:</strong> {props.empleado?.diasVacaciones}</Col>
                </Row>
            </div>
        </>
    )
}

export default EmpleadoDetallesGenerales